import { __extends } from "tslib";
import { RadioButton } from '../../primitives/radio-group/radio-group';
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import * as propTypes from 'prop-types';
import { HeightAnimation } from '../../animations/height/height';
import { DeprecatedText } from '../../deprecated-typography';
var CollapsibleRadio = /** @class */ (function (_super) {
    __extends(CollapsibleRadio, _super);
    function CollapsibleRadio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsibleRadio.prototype.render = function () {
        var props = this.props;
        var hasDescription = !!props.description;
        var disabled = !!props.disabled;
        var _a = this.context.radioGroup, selectedValue = _a.selectedValue, onChange = _a.onChange;
        var checked = props.value === selectedValue;
        var hasChildren = React.Children.toArray(this.props.children).length;
        var classNames = namespacedClassnames('collapsible-radio', props.className, { checked: checked, disabled: disabled, 'has-description': hasDescription, 'no-children': !hasChildren });
        var onClick = function () {
            if (!checked && !props.disabled) {
                onChange(props.value);
            }
        };
        var collapsibleBody = hasChildren ? (React.createElement("div", { className: 'collapsible-body' },
            React.createElement(HeightAnimation, { show: checked },
                React.createElement("div", { className: 'body-wrapper' }, props.children)))) : null;
        var descriptionText = props.description ?
            React.createElement(DeprecatedText, { className: 'header-description', type: 't1a' }, props.description) : null;
        var title = typeof props.title === 'string' ? (React.createElement(DeprecatedText, { className: 'header-title', type: 'h2a' }, props.title)) : props.title;
        return (React.createElement("div", { className: classNames, "data-value": props.value },
            React.createElement("div", { className: 'collapsible-header', onClick: onClick },
                React.createElement(RadioButton, { value: props.value, disabled: props.disabled },
                    React.createElement("span", { className: 'header-text' },
                        title,
                        descriptionText))),
            collapsibleBody));
    };
    CollapsibleRadio.contextTypes = {
        radioGroup: propTypes.object
    };
    return CollapsibleRadio;
}(React.Component));
export { CollapsibleRadio };
//# sourceMappingURL=collapsible-radio.js.map